import { ANALYTICS_SERVICE_ROUTING } from 'lib/@getethos/experiments/feature_constants'
import { useDecisionForFlag } from 'lib/FeaturesAndExperiments/getDecisionForFlag'

export const useAnalyticsService = () => {
  const { variation } = useDecisionForFlag({
    name: ANALYTICS_SERVICE_ROUTING.name,
    fallbackVariation: ANALYTICS_SERVICE_ROUTING.variations.control,
  })
}
